module.exports = "/images/mainscreenbg.jpg?3c985133c231b204d8759de8e3479412";